<div class="content-with-filled-button row">
    <div class="main col-4 col-pr-12 col-sm-8 col-md-8 col-lg-8 col-xl-8 offset-md-2 offset-lg-2 offset-xl-2">
        <div class="img-container">
            <img id="imgProcessSuccesfully" alt="error_img" src="assets/images/success-process.svg" />
        </div>
        <h2 class="title" id="titleConf">{{ copyService.getParametrizedCopy('configuration_introduction_title', [documentInfo.firstname]) }}</h2>
        <p class="subtitle" id="subtitleConf" [innerHtml]="copyService.copies.configuration_introduction_subtitle"></p>
    </div>
</div>
<app-controls id="configIntroBtns" [hasPrevious]="false" [nextLabel]="copyService.copies.configuration_introduction_next_button" (next)="next()"></app-controls>